export default __webpack_public_path__ + "static/media/share-stats-en.7d2fa352.svg";